import { CircularProgress, Fab as MaterialFab, FabProps as MaterialFabProps } from '@material-ui/core';
import React from 'react';
import {
  AlignSelfProps,
  FontSizeProps,
  HeightProps,
  JustifySelfProps,
  MaxHeightProps,
  MaxWidthProps,
  MinHeightProps,
  MinWidthProps,
  SpaceProps,
  WidthProps,
  alignSelf,
  height,
  justifySelf,
  maxHeight,
  maxWidth,
  minHeight,
  minWidth,
  space,
  width,
} from 'styled-system';
import { styled } from '~ui-kit/styled-components';

interface FabProps
  extends MaterialFabProps,
    SpaceProps,
    AlignSelfProps,
    JustifySelfProps,
    HeightProps,
    MinHeightProps,
    MaxHeightProps,
    WidthProps,
    MinWidthProps,
    MaxWidthProps,
    FontSizeProps {
  isLoading?: boolean;
}

export function Fab({ isLoading, children, ...props }: FabProps) {
  return (
    <StyledFab variant="extended" {...props}>
      {isLoading ? <CircularProgress color="secondary" size={16} /> : children}
    </StyledFab>
  );
}

const StyledFab = styled(MaterialFab)`
  && {
    ${alignSelf};
    ${justifySelf};
    ${height};
    ${minHeight};
    ${maxHeight};
    ${width};
    ${minWidth};
    ${maxWidth};
    ${space};
  }
`;
